import React, { Component } from 'react';
import { translate } from '../../../base/i18n/functions';
// import Popover from '../../../base/popover/components/Popover.web';
import HangupToggleButton from './HangupToggleButton';
import { IconArrowUp } from '../../../base/icons/svg';
import ToolboxButtonWithIcon from '../../../base/toolbox/components/web/ToolboxButtonWithIcon';
import { Popover } from '@mui/material';
class HangupMenuButton extends Component {
    /**
     * Initializes a new {@code HangupMenuButton} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this.state = {
            anchorEl: null
        };
        this._onEscClick = this._onEscClick.bind(this);
        this._toggleDialogVisibility = this._toggleDialogVisibility.bind(this); // Bind the method here
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onCloseDialog();
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { children, isOpen, t, showLabel, isShowTooltip } = this.props;
        return (React.createElement("div", { className: 'toolbox-button-wth-dialog context-menu' },
            React.createElement(ToolboxButtonWithIcon, { ariaExpanded: isOpen, ariaHasPopup: true, buttonKey: 'buttonKey', icon: IconArrowUp, iconDisabled: false, iconId: 'hangup-button', iconTooltip: t('toolbar.hangupOptions'), notifyMode: 'notifyMode', onIconClick: this._toggleDialogVisibility, onIconKeyDown: () => { } },
                React.createElement(HangupToggleButton, { buttonKey: 'hangup-menu', customClass: 'hangup-menu-button item-toolbox-custom', afterClick: this._toggleDialogVisibility, isOpen: isOpen, notifyMode: this.props.notifyMode, onKeyDown: this._onEscClick, showLabel: showLabel, isShowTooltip: isShowTooltip })),
            React.createElement(Popover, { anchorEl: this.state.anchorEl, open: Boolean(this.state.anchorEl), onClose: () => this.setState({
                    anchorEl: null
                }), anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, onClick: () => this.setState({
                    anchorEl: null
                }), sx: [
                    {
                        '& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded': {
                            backgroundColor: 'transparent'
                        }
                    },
                    {
                        '& .maxheight-custom': {
                            margin: 0
                        }
                    }
                ] }, children)));
    }
    /**
     * Callback invoked when {@code InlineDialog} signals that it should be
     * close.
     *
     * @private
     * @returns {void}
     */
    _onCloseDialog() {
        this.props.onVisibilityChange(false);
    }
    /**
     * Callback invoked to signal that an event has occurred that should change
     * the visibility of the {@code InlineDialog} component.
     *
     * @private
     * @returns {void}
     */
    _toggleDialogVisibility(event) {
        // sendAnalytics(createToolbarEvent('hangup'));
        // this.props.onVisibilityChange(!this.props.isOpen);
        this.setState({
            anchorEl: event.currentTarget
        });
    }
}
export default translate(HangupMenuButton);
